module.exports = __webpack_public_path__ + "static/media/tips.a3d881e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tips.jpg
// module id = 1108
// module chunks = 33